import { cloneElement, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { classNames } from '../../utils/classNames';
import {
    extraNavigation,
} from '../../utils/navigation-constants/navigation-partner';
import { useTheme } from '../../theme-context';

interface INavigation {
    search?: string
}

const Navigation = ({
    search
}: INavigation) => {
    // const location = useLocation();
    const [activeRoute] = useState<string>()
    const [navigationPartnerExtra] = useState<any>(extraNavigation)
    const [loading] = useState<boolean>(false)
    const { theme } = useTheme();


    return (
        <div className='flex flex-col min-h-[100%] justify-between '>

            <>
                <div className='mb-1 pt-2'>
                    <p
                        className='px-3 mb-2 text-[#535862] dark:text-white'
                        style={{
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 400,
                            fontSize: '13px',
                            lineHeight: '100%',
                            letterSpacing: '-0.02em',
                        }}>
                        AI Agents
                    </p>

                    {!loading && navigationPartnerExtra?.map((item: any) => (
                        <NavLink
                            key={item.name}
                            to={item.href}
                            data-qa={`${(item?.name).toLowerCase().replaceAll(' ', '-')}`}
                            className={({ isActive }) =>
                                classNames(
                                    'text-base text-secondary group flex items-center hover:opacity-80 px-2 py-2 font-medium rounded-md mb-2',
                                    item?.dataQa === 'claire'
                                        ? 'bg-[#F5F5F5] dark:bg-[#2A2A2A] rounded-2xl px-4 h-12'
                                        : '',
                                    item.enabled && isActive
                                        ? item?.dataQa === 'claire'
                                            ? 'font-dm_sansregular !text-[#202020] dark:!text-white'
                                            : 'font-dm_sansregular !text-[#202020] dark:!text-white !rounded-lg'
                                        : 'font-dm_sansregular',
                                )
                            }
                        >
                            {/* <item.icon className='mr-3 flex-shrink-0 h-6 w-6 text-indigo-300' aria-hidden='true' /> */}
                            <span className={classNames(
                                'flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center',
                                item?.dataQa === 'claire' ? 'h-7 w-7' : '',
                            )}>
                                {activeRoute === item?.href ?
                                    cloneElement(item.iconActive || item.icon, {
                                        width: item?.dataQa === 'claire' ? 22 : 20,
                                        height: item?.dataQa === 'claire' ? 22 : 20,
                                    })
                                    : cloneElement(item.icon, {
                                        width: item?.dataQa === 'claire' ? 22 : 20,
                                        height: item?.dataQa === 'claire' ? 22 : 20,
                                    })
                                }
                            </span>
                            <span className={classNames(
                                item?.dataQa === 'claire' ? 'flex items-center gap-2 min-w-0 w-full' : '',
                            )}>
                                {item?.dataQa === 'claire' ? (
                                    <>
                                        <span
                                            className='shrink-0 whitespace-nowrap'
                                            style={{
                                                fontFamily: 'Inter, sans-serif',
                                                fontWeight: 500,
                                                fontSize: '16px',
                                                lineHeight: '100%',
                                                letterSpacing: '-0.02em',
                                                color: theme === 'dark' ? '#FFFFFF' : '#101010',
                                            }}>
                                            Claire
                                        </span>
                                        <span
                                            className='truncate min-w-0'
                                            style={{
                                                fontFamily: 'Inter, sans-serif',
                                                fontWeight: 400,
                                                fontSize: '16px',
                                                lineHeight: '100%',
                                                letterSpacing: '-0.02em',
                                                color:
                                                    theme === 'dark'
                                                        ? '#A4A7AE'
                                                        : '#717680',
                                            }}>
                                            AI Reservation Manager
                                        </span>
                                    </>
                                ) : (
                                    item.name
                                )}
                            </span>
                        </NavLink>
                    ))}
                </div>
            </>

        </div>
    );
};

export default Navigation;